'use strict';

import './trendChart.scss';
import TrendChartTemplate from './trendChart.html';

export default angular
  .module('maestro.directives.components.trendChart', [])

  .directive('trendChart', function() {
    return {
      restrict: 'E',
      template: TrendChartTemplate,
      scope: {
        zscore: '='
      },
      controller: function($scope) {
        init();

        // No code execution below this line
        // ---------------------------------

        function init() {
          $scope.$watch('zscore', function(newValue, oldValue) {
            draw();
          });
        }

        function draw() {
          let zscore = parseFloat($scope.zscore);
          if (zscore == null || !angular.isNumber(zscore) || isNaN(zscore)) {
            $scope.currentSection = undefined;
            $scope.markerOffset = undefined;
            return;
          }

          // Map zscore to proper section
          if (zscore < -2) {
            $scope.currentSection = 'wellBelow';
          } else if (zscore >= -2 && zscore < -1) {
            $scope.currentSection = 'below';
          } else if (zscore >= -1 && zscore <= 1) {
            $scope.currentSection = 'average';
          } else if (zscore > 1 && zscore <= 2) {
            $scope.currentSection = 'above';
          } else if (zscore > 2) {
            $scope.currentSection = 'wellAbove';
          }

          // Handle wild values to have no more than 99% of the scale
          if (zscore < -2.94) {
            zscore = -2.94;
          } else if (zscore > 2.94) {
            zscore = 2.94;
          }

          $scope.markerOffset = `${Math.round((((zscore + 3) * 100) / 6) * 100) / 100}%`;
        }
      }
    };
  })

  .name;
